// extracted by mini-css-extract-plugin
export default {"container":"Content_container__aEDyp","open":"Content_open__F8RyU","mobile":"Content_mobile__JlFfb","footer":"Content_footer__f+LjS","contentLayout":"Content_contentLayout__lJzJh"};